import { ILead, LeadsService } from '../../../services';
class LeadsListController {
    
    private leads: ILead[];

    constructor(private LeadsService: LeadsService) {
        "ngInject";
    }

    public submitLead = () => {
        this.LeadsService.all().then((leads)=> {
            this.leads = leads;
        });
    }
    
}; 



export const leadsListComponent = {
    bindings: {
        leads: '<'
    },
    controller: LeadsListController,
    template: require('./leads.list.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/crm/leads/leads.list.component.ts